import { render, staticRenderFns } from "./PaymentNewDeviceInfo.vue?vue&type=template&id=f1a46650&scoped=true"
import script from "./PaymentNewDeviceInfo.vue?vue&type=script&lang=ts"
export * from "./PaymentNewDeviceInfo.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewDeviceInfo.vue?vue&type=style&index=0&id=f1a46650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a46650",
  null
  
)

export default component.exports